import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from 'src/store/index'
import { i18n } from 'src/i18n'

import magnet from './directives/magnet'
import cursor from './directives/cursor'
import reveal from './directives/reveal'

import VueGtm from 'vue-gtm';
import VueMeta from 'vue-meta'

import { resizeEnd } from 'src/utils';

import 'src/filters'
import 'lazysizes';

// Add window resizeEnd event
resizeEnd()

// Var
Vue.config.productionTip = false
const isProd = process.env.NODE_ENV === 'production';

// Meta descriptions
Vue.use(VueMeta, {})

// GTM
if ( isProd && process.env.VUE_APP_GTM ) {

    Vue.use(VueGtm, {
        id: process.env.VUE_APP_GTM,
        queryParams: {
            gtm_auth: process.env.VUE_APP_GTM_AUTH,
            gtm_cookies_win:'x'
        },
        defer: true,
        enabled: true,
        debug: false,
        vueRouter: router,
        loadScript: true,
        // ignoredViews: [''],
        // trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    });
}

// Initial load
store.dispatch('global/initLoad')

// Vue instance
new Vue({
    el: '#vue',
    router,
    store,
    i18n,
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
